export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'defaultImageUrl',
    width: 80,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_fabricName') || '面料名称',
    field: 'fabricName',
    minWidth: 240,
    align: 'left',
    fixed: 'left',
    slots: { default: 'fabricName' },
  },
  {
    title: that.$l('table_label_standardSizes') || '规格尺寸',
    field: 'fabricSize',
    minWidth: 160,
    align: 'center',
    slots: { default: 'fabricSize' },
  },
  {
    title: that.$l('table_label_fabricQty') || '耗料数量',
    field: 'fabricQty',
    minWidth: 120,
    align: 'left',
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_subFabricInContainerQty') || '面料数量',
    field: 'subFabricInContainerQty',
    minWidth: 200,
    headerAlign: 'left',
    isTotalColumn: true,
    align: 'left',
    formatter: ({ cellValue }) => that.format(cellValue),
  },
]
